import { useLingui } from '@lingui/react'
import { bool, node } from 'prop-types'

import Modal from 'views/components/molecules/Modal'

import { SELLER_MODAL_CONTAINER_ID, SELLER_MODAL_ID } from './names'

import './SellerModal.scss'

const SellerModal = ({ children, open }) => {
  const { i18n } = useLingui()

  return (
    <Modal
      id={SELLER_MODAL_ID}
      open={open}
      size="medium"
      title={i18n._('seller.modal.title')}
    >
      <div id={SELLER_MODAL_CONTAINER_ID} />
      {children}
    </Modal>
  )
}

SellerModal.propTypes = {
  children: node,
  open: bool,
}
SellerModal.defaultProps = {
  open: false,
}

export default SellerModal
